import { AGroup } from 'components/ui/base/radio/Radio';
import styled from 'styled-components';

export const RadioGroup = styled(AGroup)`
    margin-bottom: 2.0rem;
`;
